import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth-guard';
import { MainComponent } from './shared/components/main/main.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';

const routes: Routes = [
  { path: 'auth', loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule) },
  { path:'', component:MainComponent,
    canActivate:[AuthGuard],
    children: [
      {
        path:'',
        loadChildren: () => import('./modules/admin-panel/admin-panel.module').then(m => m.AdminPanelModule),
      },
      {
        path:'farm',
        loadChildren: () => import('./modules/farm-app/farm-app.module').then(m => m.FarmAppModule),
      },
      {
        path:'warehouse',
        loadChildren: () => import('./modules/warehouse-app/warehouse-app.module').then(m => m.WarehouseAppModule),
      },
      {
        path:'labapp',
        loadChildren: () => import('./modules/labapp/labapp.module').then(m => m.LabappModule),
      },
    ]
  },
  {path: '404', component: PageNotFoundComponent},
  { path: 'labapp', loadChildren: () => import('./modules/labapp/labapp.module').then(m => m.LabappModule) },
  {path: '**', redirectTo: '/404'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
